export default "__VITE_ASSET__CaTO4Z_h__"